import { AppLoading } from '@/components/AppLoading'
import { Step4Wrapper } from '@/containers/steps/vehicle/Step4/Step4Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '@/context/MeetingRecordProvider'
import OffersAddonProvider from '@/context/OffersAddonProvider'
import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'

import { SelectedQuoteProvider } from '@/context/SelectedQuoteContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'


export function Step4Page() {
  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          <Step4Content />
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

const Step4Content = () => {
  const navigate = useNavigate()
  const { insuranceParams, isLoadingData, isContracted } = useInsuranceParams()


  useEffect(() => {
    if (!insuranceParams) return

    if (!insuranceParams.generalParams.selectedOfferId && !isLoadingData) {
      navigate('/poleas/wizard/3')
      return
    }
  }, [insuranceParams, isLoadingData])

  useEffect(() => {
    if (isContracted) navigate('/poleas/complete')
  }, [isContracted])

  return (
    <>
      {(isLoadingData) && <AppLoading />}
      {insuranceParams &&
        <MeetingRecordProvider insuranceParamsId={''}>
          <OffersAddonProvider>
            <SelectedQuoteProvider>
              <SelectedOffersAddonProvider>
                <Step4Wrapper />
              </SelectedOffersAddonProvider>
            </SelectedQuoteProvider>
          </OffersAddonProvider>
        </MeetingRecordProvider>
      }
    </>
  )
}
